import React from 'react';
// import { Button } from 'react-bootstrap';
// import CookieBanner from 'react-cookie-banner';

import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { includes } from 'lodash';

import './base.scss';

import NavBar from './../NavBar';
import Footer from './../Footer';

const baseLayout = (Component, pageTitleSuffix = "Welcome") => {
  class Base extends React.Component {

    componentDidMount() {
      window.scrollTo(0, 0);
      document.title = `BWH Best Friend | ${pageTitleSuffix}`;
    }

    render() {

      /*
      const cookieBannerStyles = {
        banner: {
          height: 'auto',
          background: 'rgba(23, 38, 96, 0.90)',
          position: 'fixed',
          bottom: 0,
          padding: 8
        },
        button: {
          border: '2px solid white',
          borderRadius: 4,
          width: 96,
          height: 32,
          lineHeight: '24px',
          background: 'transparent',
          color: 'white',
          fontWeight: 600,
          opacity: 1,
          right: 8,
          marginTop: -16
        },
        message: {
          display: 'block',
          padding: '8px 8px',
          lineHeight: 1.25,
          textAlign: 'center',
          marginRight: 108,
          verticalAlign: 'middle'
        },
        link: {
          textDecoration: 'none',
          fontWeight: 'bold',
          color: 'white',
          cursor: 'pointer'
        }
      };
      */
      /*
      const linkButtonStyles = {
        width: '96px',
        margin: '2px 4px'
      };
      */

      const inPrivacyPolicyPage = includes(this.props.location.pathname, '/privacy_policy') || includes(this.props.location.pathname, '/cookie_policy');

      return (
        <div className="base-layout-component">
          <NavBar genericTemplate={inPrivacyPolicyPage}/>
          
          <Component {...this.props}/>

          <Footer match={this.props.match} genericTemplate={inPrivacyPolicyPage} />

          {/*
          <CookieBanner message={this.props.translate('shared.layouts.base.cookie_banner_text')}
                        buttonMessage={this.props.translate('shared.layouts.base.cookie_banner_accept_button_text')}
                        onAccept={() => {}}
                        dismissOnScroll={false}
                        styles={cookieBannerStyles}
                        link={<div>
                                <Button href={`#/cookie_policy`} style={linkButtonStyles} bsSize="xsmall">Cookie Policy</Button>
                                <Button href={`#/privacy_policy`} style={linkButtonStyles} bsSize="xsmall">Privacy Policy</Button>
                              </div>
                        } />
          */}     
        </div>
      );
    }
  }

  Base.displayName = 'SharedLayoutsBase';
  Base.propTypes = {};
  Base.defaultProps = {};

  const mapStateToProps = (state) => {
    return { 
      translate: getTranslate(state.locale),
      currentLanguage: getActiveLanguage(state.locale).code
    };
  };
  
  return connect(mapStateToProps)(Base);
};

export default baseLayout;



// WEBPACK FOOTER //
// ./components/shared/layouts/Base.js